/**
 * STABILITY-CRITICAL: regras da seleção de fazendas a baixar depois da limpeza. O limite protege
 * a memória do aparelho (hipótese da telemetria da E1). Antes de alterar, leia
 * docs/llm/slices/sync-engine.md e alinhe com o responsável pelo sync.
 */
export const MAX_FARMS = 10 // mesmo limite do Home.js (selectedToSyncFarms)
export type FarmOption = { id: string; nome: string }

export const MEMORY_WARNING =
  'Baixar muitas fazendas deixa o aparelho mais lento e pode travar o navegador. Baixe só as que você vai usar agora (no máximo 10). As outras podem ser baixadas depois, uma a uma.'

export function initialSelection(
  savedIds: readonly string[],
  available: readonly FarmOption[],
  max: number = MAX_FARMS,
) {
  const ids = available.map((f) => f.id)
  const present = savedIds.filter((id) => ids.includes(id))
  return {
    selected: present.slice(0, max),
    missing: savedIds.length - present.length,
    truncated: Math.max(0, present.length - max),
  }
}

export function toggleFarm(
  selected: readonly string[],
  id: string,
  max: number = MAX_FARMS,
) {
  if (selected.includes(id))
    return { selected: selected.filter((x) => x !== id), blocked: false }
  if (selected.length >= max) return { selected: [...selected], blocked: true }
  return { selected: [...selected, id], blocked: false }
}
